<template>
  <div data-testid="no-franchise-empty-state" class="no-franchise-empty-state">
    <div class="no-franchise-empty-state__icon">
      <i class="pi pi-info-circle" />
    </div>
    <h3 class="no-franchise-empty-state__title">
      {{ t('Nenhuma franquia vinculada') }}
    </h3>
    <p class="no-franchise-empty-state__body">
      {{ t('Você ainda não é dono de nenhuma franquia neste sistema. Procure o administrador da sua rede para vincular seu usuário a uma franquia.') }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
.no-franchise-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  gap: 16px;
}

.no-franchise-empty-state__icon {
  font-size: 3rem;
  color: #6c757d;
}

.no-franchise-empty-state__title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

.no-franchise-empty-state__body {
  color: #6c757d;
  max-width: 480px;
  margin: 0;
}
</style>
